import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course02 from "../../../course/course-02/course";
import course05 from "../../../course/course-05/course";
import lesson0201 from "../../course-02/lesson-01/lesson";
import lesson0502 from "../lesson-12/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "0821f984-2520-42e1-9056-efe53ea1e31f",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0201),
    lesson: lesson0201,
  },
  {
    id: "82a3e777-bd4e-4afa-9ab6-53955b991d4c",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0502),
    lesson: lesson0502,
  },
];

export default lessonLinks;
